/**
 * Shared write-tracking types and helpers for Excel edit tools.
 *
 * Every edit tool (editContent, editFormat, editChart, editStructure) returns
 * `_excelReadInfos` entries so the host's reminder system can track what was
 * modified.  Tools also return `_rawImages` so the host framework can store
 * post-edit screenshots into its context system (e.g. ContextResolver for PPT).
 */
// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
let _imageCounter = 0;
export function generateImageId(prefix, label) {
    _imageCounter += 1;
    const safeLabel = label
        ? label.replace(/[^a-zA-Z0-9_-]/g, "_").slice(0, 40)
        : "";
    return safeLabel
        ? `${prefix}_${safeLabel}_${Date.now()}_${_imageCounter}`
        : `${prefix}_${Date.now()}_${_imageCounter}`;
}
export function buildWriteEntry(track, sheetName, rangeA1, detailLevel, storedImageId) {
    return {
        track,
        type: "write",
        sheetName: sheetName || "Unknown",
        rangeA1: rangeA1 || "FULL_SHEET",
        detailLevel,
        detailRank: 100,
        timestamp: Date.now(),
        imageIds: storedImageId ? [storedImageId] : undefined,
    };
}
export function collectImagesFromResult(images, prefix) {
    const imageIds = [];
    const rawImages = [];
    for (const img of images) {
        if (!img.base64)
            continue;
        const id = generateImageId(prefix, img.label);
        imageIds.push(id);
        rawImages.push({ id, base64: img.base64, mimeType: "image/png" });
    }
    return { imageIds, rawImages };
}
